import { type BaseProductElementProps } from "~/feature/Product/types";
import { useProductContext } from "~/feature/Product/ProductContext";
import { Translation } from "~/common/Translation";
import { Link, type LinkProps, LinkType } from "~/common/components/Link";
import { useProductDetailsUrl } from "~/common/components/PackageRestrictionContext/useProductDetailsUrl";
import type { ReactNode } from "react";
import classNames from "classnames";
import classes from "./ShortDescription.module.less";

interface Props extends BaseProductElementProps {
  as?: keyof JSX.IntrinsicElements;
  clickable?: boolean;
  linkProps?: LinkProps;
  truncate?: boolean;
}

export const ShortDescription = (props: Props) => {
  const { clickable = true, linkProps } = props;
  const product = useProductContext(props);
  const Cmp = props.as ?? "div";

  let href: string | undefined = useProductDetailsUrl(product);
  if (linkProps?.href) {
    href = linkProps.href;
  }

  let content: ReactNode = <Translation {...product.shortDescription} />;

  if (clickable && href) {
    content = (
      <Link href={href} variant={LinkType.SECONDARY} {...linkProps}>
        {content}
      </Link>
    );
  }

  return <Cmp className={classNames(props.className, props.truncate && classes.truncate)}>{content}</Cmp>;
};
